import React from 'react';
import ctrl from 'controllers/cotacao-ctrl';
import utils from 'utils/utils';
import Row from 'components/row';
import Col from 'components/col';
import FormComboBox from 'components/form-combo-box';
import FormInput from 'components/form-input';

module.exports = React.createClass({

  handleFornecedor(value){
    ctrl.requestFornecedor(parseInt(value)).success(function(){
      ctrl.selectItem();
    });
  },

  render(){
    return (
      <form>
        <Row>
          <FormComboBox size="sm-12" data={ctrl.data.fornecedores} emptyItem={ctrl.data.fornecedor==-1} value={ctrl.data.fornecedor} onChange={this.handleFornecedor} label="Fornecedor"/>
        </Row>
        <Row>
          <FormInput size="sm-3" value={ctrl.data.cotacao.id} readOnly={true} label="ID Cotação" />
          <FormInput size="sm-3" value={utils.dateToStr(ctrl.data.cotacao.dataEntrega)} readOnly={true} label="Data Entrega"/>
          <FormInput size="sm-3" value={utils.dateToStr(ctrl.data.cotacao.dataEncerra)} readOnly={true} label="Data Encerramento"/>
          <FormInput size="sm-3" value={ctrl.dadosFornec.notaFornecedor} readOnly={true} label="Qualif." />
        </Row>
        <Row>
          <FormComboBox size="sm-6" data={ctrl.data.grupos} value={ctrl.data.filtroGrupo} onChange={ctrl.setFiltroGrupo} label="Filtro Grupo"/>
          <FormComboBox size="sm-6" data={ctrl.data.marcas} value={ctrl.data.filtroMarca} onChange={ctrl.setFiltroMarca} label="Filtro Marca"/>
        </Row>
      </form>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/cotacao-header.js
 **/